import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

function SidebarItem({
  Icon,
  title,
  path,
  iconClassName,
  NavLink,
  useLocation,
  isCollapsed = false,
}) {
  const location = useLocation();

  const isActive =
    location.pathname === "/" + path ||
    location.pathname.includes(path + "/") ||
    (path === "/" && location.pathname === "/");

  const linkClassName = [
    isActive ? "bg-primary text-secondary font-semibold" : "text-background/90 hover:bg-background/10",
    "h-9 w-full rounded-lg flex items-center font-ptsans cursor-pointer shrink-0 transition-colors ease-in duration-150 outline-secondary/80",
    isCollapsed ? "justify-center p-0 !w-9" : "p-2 gap-2",
  ].join(" ");

  const link = (
    <NavLink to={path} end className={linkClassName}>
      <Icon className={`w-5 h-5 shrink-0 ${iconClassName ?? ""}`} />
      {!isCollapsed && (
        <span
          className={`text-body2 leading-none whitespace-nowrap overflow-hidden ${
            isActive ? "font-semibold" : "font-normal"
          }`}
        >
          {title}
        </span>
      )}
    </NavLink>
  );

  if (isCollapsed) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{link}</TooltipTrigger>
        <TooltipContent
          side="right"
          align="center"
          className="z-50"
          sideOffset={8}
        >
          {title}
        </TooltipContent>
      </Tooltip>
    );
  }

  return link;
}

export default SidebarItem;
